import fetchInstance from "@/services/fetch.ts";
import { IUser } from "@/interfaces/IUser.ts";
import { ConnectionType } from "@/types/types.ts";

export async function updateUserProfile(userId: string, data: Partial<IUser>) {
  return await fetchInstance.post(`/update-profile/${userId}`, data);
}

export const fetchConnectionInfo = async (
  connectionId: string,
  connectionType: ConnectionType,
) => {
  return fetchInstance.get(`/connections-info/${connectionId}/${connectionType}`)
}

export const fetchBandConnectionsByUserId = async (
  userId: string,
) => {
  return fetchInstance.get(`/band-connections/${userId}`)
}

export const fetchUserConnectionsByUserId = async (
  userId: string,
) => {
  return fetchInstance.get(`/user-connections/${userId}`)
}

export const fetchUserNotifications = async (
  userId: string,
) => {
  return fetchInstance.get(`/user-notifications/${userId}`)
}

export const userNotificationSetIsRead = async (
  notificationId: string,
) => {
  return fetchInstance.post(`/user-notification-is-read/${notificationId}`)
}
